import moment from "moment-jalaali";

interface TimeSlot {
  start: string;
  end: string;
  isReserved: boolean;
  disabled: boolean;
}

export function getTimeSlots(
  startTimeOfDay: string,
  endTimeOfDay: string,
  durationPartInMinute: number,
  selectedAppointmentDate: Date
): TimeSlot[] {
  const start = new Date(`1970-01-01T${startTimeOfDay}`);
  const end = new Date(`1970-01-01T${endTimeOfDay}`);
  const result: TimeSlot[] = [];

  let current = new Date(start);
  const timeNow = moment().format("HH:mm");
  const isToday =
    new Date().getDate() ===
    new Date(new Date(selectedAppointmentDate))?.getDate();

  while (current < end) {
    const next = new Date(current);
    next.setMinutes(current.getMinutes() + durationPartInMinute);

    if (next > end) break;
    const startTime = current.toTimeString().slice(0, 5);
    const endTime = next.toTimeString().slice(0, 5);
    result.push({
      start: startTime,
      end: endTime,
      isReserved: false,
      disabled: isToday && startTime < timeNow && endTime < timeNow,
    });

    current = next;
  }

  return result;
}
